import { Badge } from "@f2e/ui/components/base"

import { Agent } from "@/types"
import { SourceBadgeContent } from "@/components"
import type { KnowledgeBaseFolder } from "@/hooks/api"

interface AgentSourceBadgeGroupProps {
  agent: Agent
  knowledgeBaseMap: Map<string, KnowledgeBaseFolder>
}

const AgentSourceBadgeGroup = ({
  agent,
  knowledgeBaseMap,
}: AgentSourceBadgeGroupProps) => {
  // Extract knowledge base tools from unified tools
  const knowledgeTools =
    agent.unifiedTools?.filter((tool) => tool.type === "knowledge_base") || []
  const listNum = agent.useSearch ? 4 : 5
  const showMore = knowledgeTools.length > listNum
  const sources = showMore ? knowledgeTools.slice(0, listNum) : knowledgeTools

  return (
    <>
      {agent.useSearch && (
        <Badge variant="secondary">
          <SourceBadgeContent isWebSearch />
        </Badge>
      )}
      {sources.map((tool) => (
        <Badge
          key={tool.id}
          variant="secondary"
          className="text-wrap break-all"
        >
          <SourceBadgeContent
            name={(() => {
              const nodeIds = tool.knowledgeNodeIds ?? []
              if (nodeIds.length === 0) return tool.name
              const firstName =
                knowledgeBaseMap.get(String(nodeIds[0]))?.name ?? tool.name
              if (nodeIds.length === 1) return firstName
              return `${firstName} +${nodeIds.length - 1}`
            })()}
          />
        </Badge>
      ))}
      {showMore && <Badge variant="secondary">...</Badge>}
    </>
  )
}

export { AgentSourceBadgeGroup }
export default AgentSourceBadgeGroup
